import { useEffect, useState } from 'react'

import { EmployeePulseQuestionHookConfigurationDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

export interface EmployeePulseQuestion {
  questionType: 'daily_question' | 'weekly_question' | 'custom'
  question: string
  enabled: boolean
}

// Función helper para obtener el texto de la pregunta según el tipo
function getQuestionText(questionType: string, customQuestion?: string): string {
  switch (questionType) {
    case 'daily_question':
      return (
        i18n.t('engagement.pulse.activation.message.daily_question.title') ||
        'How are you feeling today?'
      )
    case 'weekly_question':
      return (
        i18n.t('engagement.pulse.activation.message.weekly_question.title') ||
        "How's your week going so far?"
      )
    case 'custom':
      return customQuestion || ''
    default:
      return (
        i18n.t('engagement.pulse.activation.message.daily_question.title') ||
        'How are you feeling today?'
      )
  }
}

export function useEmployeePulseQuestion() {
  const [pulseQuestion, setPulseQuestion] = useState<EmployeePulseQuestion | null>(null)

  const { company } = useCurrentSession()
  const { data, loading, error } = useQuery(EmployeePulseQuestionHookConfigurationDocument, {
    variables: { companyIds: company.id },
  })

  useEffect(() => {
    if (data?.engagement?.settingsConnection?.edges?.length) {
      const settings = data.engagement.settingsConnection.edges[0]?.node

      if (settings) {
        const questionData: EmployeePulseQuestion = {
          questionType: settings.questionType || 'daily_question',
          question: getQuestionText(
            settings.questionType || 'daily_question',
            settings.question || undefined
          ),
          enabled: settings.employeePulseEnabled || false,
        }

        setPulseQuestion(questionData)
      }
    }
  }, [data])

  return {
    pulseQuestion,
    loading,
    error,
  }
}
